import styled, { css } from "styled-components";
import { IconButton, TextField } from "@material-ui/core";
import PlaySound from "@material-ui/icons/PlayCircleFilled";
import StopSound from "@material-ui/icons/PauseCircleFilled";

export const Container = styled.div`
  position: absolute;
  right: 0;
  width: 300px;
  z-index: 9999;
  height: calc(100vh - 65px);
  background-color: #f0f1f3;
  border-bottom-left-radius: 10px;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font-size: 24px;
  padding: 16px;
  color: white;
  font-weight: bold;
`;

export const ExampleContainer = styled.div`
  font-size: 11px;
  padding: 16px;
  color: white;
  text-align: left;
  background: #026eda;
  border-radius: 10px;
  margin-top: 10px;
  width: fit-content;
  cursor: pointer;
`;

export const GoBack = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 15px;
  left: 10px;
  font-size: 24px;
  background: white;
  flex: 1;
  padding: 16px;
  width: 30px;
  height: 30px;
  border-radius: 50px;
  cursor: pointer;
  color: white;
`;

export const BotChatContainer = styled.div`
  display: flex;
  height: calc(100% - 65px);
  flex-direction: column;
`;

export const MessageContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: auto;
`;

export const BotMessage = styled.div`
  background: #fff;
  font-size: 16px;
  color: white;
  margin: 16px;
  margin-bottom: 0px;
  margin-top: 0px;
  padding: 16px;
  border-radius: 10px;
  width: fit-content;
  max-width: 60%;
  min-width: 250px;
  position: relative;
`;

export const BotMessageOption = styled.div`
  background: #fff;
  font-size: 16px;
  color: white;
  margin: 16px;
  margin-bottom: 0px;
  margin-top: 10px;
  padding: 16px;
  border-radius: 10px;
  width: fit-content;
  max-width: 60%;
  min-width: 250px;
  position: relative;
  cursor: pointer;
  font-weight: bold;
`;

export const HumanMessage = styled.div`
  background: linear-gradient(
    315deg,
    rgba(8, 57, 169, 1) 0%,
    rgba(10, 115, 219, 1) 100%
  );
  text-transform: none;
  color: #fff;
  font-size: 16px;
  margin: 16px;
  padding: 10px;
  padding-left: 16px;
  padding-right: 16px;
  border-radius: 10px;
  display: block;
  margin-left: auto;
  width: fit-content;
  max-width: 89%;
  overflow: hidden;
`;

export const BotMessageText = styled.div`
  color: black;
  font-size: 12px;
  text-decoration: none;
`;

export const HumanShowMore = styled.div`
  color: white;
  font-size: 12px;
  font-weight: bold;
  border-top: 1px solid white;
  text-align: center;
  padding-top: 10px;
  margin-top: 10px;
  cursor: pointer;
`;

export const HumanMessageText = styled.div`
  color: white;
  font-size: 12px;
  font-weight: bold;
  ${({ textOverflow }) =>
    textOverflow
      ? css`
          max-height: 400px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-overflow: ellipsis;
          padding-bottom: 2px;
        `
      : null}
`;

export const SendMessageContainer = styled.div`
  align-self: flex-end;
  width: 100%;
  margin-bottom: 10px;
  justify-content: flex-end;
  align-items: flex-end;
`;
export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const CustomTextField = styled(TextField)`
  flex: 1;
  width: 100%;
  background: white;
  margin-left: 16px;
  margin-right: 16px;
  border-radius: 10px;
  margin-top: 10px;
  padding-left: 10px;
  height: 42px;
`;

export const SendButton = styled(IconButton)`
  color: white;
  background: #006ee3;
  margin-left: 10px;
  margin-right: 10px;
`;

export const AudioButton = styled(IconButton)``;

export const TopicContainer = styled.div``;

export const PopularTopic = styled.div`
  background: linear-gradient(
    315deg,
    rgba(8, 57, 169, 1) 0%,
    rgba(10, 115, 219, 1) 100%
  );
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.16);
  color: white;
  margin-left: 20px;
  margin-right: 20px;
  padding: 8px 16px 8px 16px;
  border-radius: 8px;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 10px;
`;

export const TopicCard = styled.div`
  cursor: pointer;
  background: rgba(255, 255, 255, 1);
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 10px;
`;

export const TopicTitle = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  color: rgba(0, 54, 179, 1);
  margin-left: 5px;
`;

export const FastTitle = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: 700;
  line-height: 22px;
  text-align: left;
  color: rgba(66, 66, 66, 1);
`;

export const TopicDescription = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
`;

export const Disclaimer = styled.div`
  color: grey;
  font-size: 10px;
`;

export const KnowledgeBaseCardText = styled.div`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-size: 12px;
`;

export const KnowledgeBaseCardContainer = styled.div`
  margin-top: 15px;
  margin-left: 16px;
`;

export const KnowledgeBaseCard = styled.div`
  background: white;
  color: black;
  padding: 10px;
  font-size: 12px;
  margin-top: 10px;
  border-radius: 10px;
  margin-right: 10px;
  cursor: pointer;
`;

export const CourseCard = styled.div`
  background: white;
  color: black;
  border-radius: 10px;
  margin-right: 10px;
  cursor: pointer;
`;

export const KnowledgeBaseContainer = styled.div`
  position: absolute;
  right: 80px;
  top: 54px;
  padding-left: 20px;
  background: #036edb;
  cursor: pointer;
  display: flex;
  padding: 8px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;

export const KnowledgeBaseText = styled.div`
  color: white;
  padding-left: 10px;
  font-weight: bold;
  font-size: 12px;
`;

export const PlaySoundContainer = styled.div`
  display: flex;
  background: #fff;
  font-size: 16px;
  color: white;
  margin-top: 8px;
  margin-left: 16px;
  margin-right: 16px;
  padding: 6px;
  border-radius: 10px;
  width: fit-content;
  max-width: 60%;
  min-width: 250px;
  position: relative;
`;

export const PlaySoundIcon = styled(PlaySound)`
  cursor: pointer;
  color: #073398;
`;

export const StopSoundIcon = styled(StopSound)`
  cursor: pointer;
  color: #073398;
`;

export const AudioSize = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #eeeeee;
  color: #858585;
  font-size: 10px;
  width: 60px;
  border-radius: 10px;
  padding-left: 10px;
  padding-right: 10px;
`;

export const KnowledgeBaseIcon = () => {
  return (
    <svg
      id="uuid-35fe8217-c68f-4cce-b8cf-fb347b2498ea"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26.5583 22.56002"
      fill={"#fff"}
      width={20}
      height={20}
    >
      <defs>
        <style></style>
      </defs>
      <g id="uuid-2194e3cb-99ab-4220-8037-2ce19fd6541a">
        <g>
          <path
            class="uuid-d594d01e-6c40-4ee9-90fb-1158c18051e1"
            d="m26.52,15.42623c-.0918-.25977-.33105-.42578-.61133-.42578h-.00781c-.14453.00195-.25977.05664-.36133.11426l-10.84277,6.10254c-.03125.01758-.05078.02734-.05957.02832-.33594-.08008-.67188-.15332-1.00781-.22656l-10.31641-2.26172c-.33594-.07227-.67285-.14453-1.00879-.21973-.43359-.09668-.72461-.33887-.88867-.74023-.10742-.25684-.14062-.54199-.10449-.87012.03125-.28027.12402-.53027.27637-.74316l.00098-.00098c.14551-.2041.31348-.33496.51172-.39941.08984-.0293.16211-.03418.22949-.01953l12.22461,2.6875c.19922.04395.38965.01562.56348-.08398.23438-.13477.4707-.26758.70703-.40039l10.19336-5.73535.05859-.03223c.06641-.03613.13379-.07227.19531-.11426.2207-.15039.32129-.38672.27539-.64746-.04395-.25098-.21289-.43652-.46289-.50781-.24805-.07227-.45898.04395-.5293.08203l-2.10156,1.18359c-2.92773,1.64746-5.85547,3.29492-8.82422,4.9541-.44141-.09961-.88281-.19629-1.32324-.29297l-10.98535-2.4082c-.48047-.10449-.78809-.37988-.93945-.84277-.03418-.10156-.05664-.20312-.06738-.30371-.05469-.47852.03809-.87891.28418-1.22461.1377-.19434.30078-.32031.49707-.38379.09668-.03223.17578-.03809.25977-.01758.26074.06152.52246.11816.78418.1748l4.11914.9043c.32129.07129.64355.14258.96387.21191.2793.05957.51172-.02246.67188-.23145.13477-.17285.17188-.39746.10156-.60156-.07227-.20703-.24512-.36328-.46289-.41602-.18262-.0459-.36621-.08594-.55078-.125l-5.01855-1.09863c-.21973-.04688-.43945-.09277-.6582-.14258-.46777-.10547-.77051-.37793-.92383-.83301-.0752-.22168-.09961-.46094-.07422-.73242.03027-.33105.13574-.60645.32129-.84277.13672-.17383.28711-.28418.49219-.34375l10.91211,2.33984c.51074.1084,1.02148.21777,1.53027.33008.20117.04395.38867.01465.61035-.11914l10.95215-6.16406c.05859-.03125.11621-.06348.1709-.10352.19824-.14648.28906-.36133.25488-.60742-.0332-.24023-.17871-.42188-.40527-.50977-.04199-.01758-.08594-.02832-.15332-.04297l-8.14844-1.79199c-1.37402-.30078-2.74805-.60254-4.12305-.90723-.22559-.05078-.4248-.02051-.62305.08984L1.80515,6.30319l-.05859.0332c-.03516.02051-.07031.04199-.10547.05566-.56445.21094-1.00098.60742-1.29785,1.17871-.27344.52832-.37988,1.10938-.31641,1.72559.07031.68262.33496,1.24609.80469,1.70117-.22168.2168-.40137.47168-.53613.76172-.2832.6084-.35742,1.25879-.22266,1.93359.11133.55957.36719,1.02734.76172,1.39453-.14648.13965-.26465.28711-.36133.44531-.53613.88086-.61719,1.81152-.24023,2.76758.26953.69043.77734,1.16602,1.50586,1.41406.14062.04785.28613.07812.43164.1084l7.57129,1.66113c1.59473.35059,3.18945.70117,4.78418,1.05371.06934.01562.13672.02246.20215.02246.14453,0,.28125-.03711.41406-.1123,1.02539-.58008,2.05273-1.1582,3.08008-1.73633l7.96875-4.48438c.04199-.02344.08301-.04785.11816-.07617.21973-.1709.30469-.46191.21094-.72461Z"
          />
          <path
            class="uuid-d594d01e-6c40-4ee9-90fb-1158c18051e1"
            d="m9.12351,9.89108l-.03906.25c-.00391.02832-.03906,4.10449.03223,4.33594l.09473.30566,1.0459-.62891.01172.0127c.11621.12891.22852.25391.34375.37598.05859.0625.11523.12598.17188.18945.10352.11621.20605.23145.31738.33887l.15039.11133.29688-.14844v-1.45734c.09174.09485.21161.16766.35938.2005l.6709.14746c.64844.1416,1.29688.2832,1.94434.42871.06934.01562.13672.02344.20312.02344.14355,0,.28027-.03711.41309-.1123,1.01465-.5752,2.03125-1.14648,3.04883-1.71875l7.9873-4.49414c.03906-.02246.07715-.04395.1123-.06934.25977-.18555.34473-.53906.19629-.82324-.1543-.29004-.49902-.42188-.80176-.2998-.05273.01953-.10156.04688-.16016.08008l-10.87012,6.12207c-.52344-.11816-1.04883-.23242-1.57324-.34668l-.24414-.05371c-.23828-.05371-.47754-.10645-.7168-.15137-.18457-.03613-.37305.01367-.5166.13281-.02277.01898-.03308.04724-.05273.06885v-2.41846l-2.42578-.40137Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const ItemRelatedButton = styled.div`
  background: #fff;
  width: fit-content;
  position: relative;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 10px;
  border: 2px solid #2d59c0;
  color: #2d59c0;
  cursor: pointer;
  font-weight: bold;
  font-size: 12px;
`;

export const BadgeButton = styled.div`
  font-weight: 100;
  position: absolute;
  top: -5px;
  left: -5px;
  background-color: #2d59c0;
  color: white;
  border-radius: 10px;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 11px;
`;
